import $ from 'jquery'
import _ from 'lodash'
import template from './datasets-overview.hbs'
import i18n from 'scoreboard/components/i18n'
import icon from 'scoreboard/components/icon'
import DatasetsTabularResult from './datasets-tabular-result'
import DatasetsValueResult from './datasets-value-result'
import selects from 'scoreboard/components/selects'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import DatasetsQueryView from '../datasets-query-view'
import TableSettings from './table-settings'
import Tooltip from 'scoreboard/components/tooltip'
import arrayToHash from 'scoreboard/components/array-to-hash'
import ChangeTotalDisplay from '../change-total-display'
import appDisplay from 'scoreboard/components/app-display'
import ChooseColumns from './choose-columns'
import RepeatByGroupingWizard from 'scoreboard/datasets/overview/repeat-by-grouping-wizard'
import Dataset from '../model/dataset'
const { ALL_TIME, TOTAL } = Dataset
import FieldList from './field-list'
import loadingDots from 'scoreboard/components/loading-dots.hbs'
import loadingPanel from 'scoreboard/components/loading-panel.hbs'
import fieldAggregationDescription from 'scoreboard/datasets/field-aggregation-description'
import highlight from 'scoreboard/components/highlight'
import totalTooltip from './total-tooltip.hbs'
import DatasetSeriesCreator from '../dataset-series-creator'
import permissions from 'scoreboard/components/permissions'
import spotlight from 'scoreboard/components/spotlight'
import addFirstHint from 'scoreboard/components/add-first-hint.hbs'
import applyFilter from '../apply-filter'
import datasetsOverviewExport from './datasets-overview-export'
import renderFieldDropdown from '../render-field-dropdown'
import cellTooltipTemplate from './cell-tooltip-template.hbs'
import globals from 'scoreboard/components/globals'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'
import DatasetTable from 'scoreboard/datasets/model/dataset-table'
import hasRelativeDateFilter from '../has-relative-date-filter'
import { getRepeatByGroupingKey, getRepeatByGroupingType } from 'scoreboard/datasets/overview/get-repeat-by-grouping'
import showPartialError from 'scoreboard/datasets/show-partial-error'
import ViewTableDataSource from './view-table-data-source'
import { shouldShowCreateDatasetMetricTooltip } from 'scoreboard/datasets/overview/cell-tooltip'
import momentHelper from 'scoreboard/components/moment-helper'
import isGeographicOrRollup from '../is-geographic-or-rollup'
import constants from 'scoreboard/components/constants'
import updateSimilarTimeRanges from 'scoreboard/datasets/update-similar-time-ranges'
import getAggregatedDataType from 'scoreboard/components/get-aggregated-data-type'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import formatHtmlValue from 'scoreboard/components/format-html-value'
import { LIST_UNIQUE_VALUES } from '../model/aggregation-type'

var DatasetsOverview = DatasetsQueryView.extend({

	className: 'display-layout table-hack datasets-overview ' + DatasetsQueryView.prototype.className,

	/** @type {Dataset} */
	model: null,

	events: _.defaults({
		'change select.field': 'addField',
		'click .total .settings': 'totalSettings',
		'click .total-error': 'onClickTotalError',
		'click .field-list': 'fieldList',
		'click .banner .hide-banner': 'removeBanner',
		'mouseenter .drilldown': 'rowHighlights',
		'mouseleave .drilldown': 'rowHighlights'
	}, DatasetsQueryView.prototype.events),

	// retrieve tables when new queries are retrieved
	showTables: true,
	// retrieve the total when queries are retrieved
	total: true,
	/** @type {DatasetTable[]} */
	tables: null,

	render: function() {
		this.$el.toggleClass('opening-transition', this.options.openingTransition == true)

		this.createHeader('overview')
		this.header.render()

		this.$el.empty().append(this.header.el, template())

		this.togglePeriodDisplay()
		this.renderSaveControls()

		this.$('.total .loading-dots-container').append(loadingDots())

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		this.renderHint()
		this.renderFieldDropdown()
		this.prepFilters()
		this.renderQueryResults()
		this.secure()
		this.guard()
		this.spotlightDatasetSeries()
		this.doOpeningTransition()
		this.showRecalculationBannerIfNeeded()
		this.on('resize', this.positionHeaderContent)

		return this
	},

	doOpeningTransition: function() {
		process.nextTick(() => {
			// Perform the opening animation should that be necessary
			if (this.options.openingTransition) {
				this.$('.filters-overview-controls-wrapper').one('transitionend', () => {
					this.$('.add-first-hint').one('transitionend', () => {
						this.$el.removeClass('opening-transition')
						this.$('.filters-overview-controls-wrapper').removeClass('fade-in')
					})

					this.$('.add-first-hint').addClass('fade-in')
				})

				this.$('.filters-overview-controls-wrapper').addClass('fade-in')
				this.options.openingTransition = false
			}
		})
	},

	spotlightDatasetSeries: function() {
		const datasetSeries = this.options.datasetSeries
		if (!datasetSeries) {
			return
		}

		let panelFieldId = _.get(datasetSeries, 'value.fieldId')
		// selector used to find what should be spotlighted
		let selector
		if (panelFieldId) {
			// data to search for using data- attributes
			let data = {
				fieldId: datasetSeries.columnFieldId || TOTAL,
				aggregationType: datasetSeries.columnAggregationType,
				datasetId: _.get(datasetSeries, 'columnDatasetId'),
				value: _.get(datasetSeries, 'value.value'),
				row: _.get(datasetSeries, 'row.value'),
				column: _.get(datasetSeries, 'column.value')
			}
			// build selector used to find element to spotlight
			selector = `[data-field-id=${panelFieldId}] `
			_.each(data, (value, key) => {
				if (!_.isNil(value)) {
					selector += `[data-${_.kebabCase(key)}="${value}"]`
				}
			})
		} else {
			// handle non-tabular results

			// doesn't make sense to spotlight percentage numbers
			if (datasetSeries.aggregationType === 'percentage') {
				return
			}

			let filter = _.find(this.filters,
				f => f.fieldId == datasetSeries.columnFieldId)
			if (filter && (filter.rows === 'average' || filter.rows === 'sum' ||
				filter.rows === 'minimum' || filter.rows === 'maximum')) {
				selector = `[data-field-id=${filter.fieldId}] tbody td`
			} else {
				// spotlight the total display
				selector = '.total .panel'
			}
		}

		let el = this.$(selector)
		if (!_.isEmpty(el)) {
			el.css('animation-iteration-count', 3)
			el[0].scrollIntoView(false)
			// the length of the animation in ms
			const animationDuration = 500
			// the length of the delay between animations
			const animationBreak = 100
			// length of time after one animation displays before the next should
			// display
			const nextAnimation = animationDuration + animationBreak
			// run the animation 3 times
			spotlight(el)
			setTimeout(() => spotlight(el), nextAnimation)
			setTimeout(() => spotlight(el), nextAnimation * 2)
		}
	},

	// renders the field dropdown
	renderFieldDropdown: function() {
		let tableFieldIds = arrayToHash(_.map(this.tables, t => t.fieldId))
		let tableVisibleLinkedFieldIds = arrayToHash(_(this.tables)
			.map(t => t.visibleLinkedFieldId)
			.filter(id => !_.isNil(id))
			.value())

		let allowedVisibleLinkedFields = _.filter(this.model.get('visibleLinkedFields'), vlf => {
			if (vlf.id < 0) {
				// #27291 don't show the "fake" vlfs added by MissingVlfCreator
				return false
			}

			let field = this.model.combinedFieldsById[vlf.fieldId]
			return !tableVisibleLinkedFieldIds[vlf.id] &&
				// it doesn't really make sense to display a table for a field that
				// can't be aggregated
				_.get(field, 'aggregationType') !== 'none'
		})
		var fields = _.filter(this.model.combinedFields, field => {
			let underlyingField = this.model.getUnderlyingField(field)
			return !tableFieldIds[field.id] &&
				// disallow non-rollup primary key fields (i.e. text, numeric)
				!(field.primaryKey && !isGeographicOrRollup(underlyingField.dataType))
		})
		// it doesn't really make sense to display a table for a field that
		// can't be aggregated
		_.remove(fields, field => field.aggregationType === 'none')

		renderFieldDropdown({
			el: this.$('select.field').empty(),
			dataset: this.model,
			allowedFieldIds: _.map(fields, 'id'),
			includeTotal: true, // #55779
			allowedVisibleLinkedFieldIds: _.map(allowedVisibleLinkedFields, 'id'),
			includeEditFields: true
		})
	},

	// renders a hint for adding first filter on an empty overview
	renderHint: function () {
		// #14810 show hint on empty overview
		this.$('.add-fields').append(addFirstHint({hint: i18n.get('datasets.fields.choose.hint')}))
		this.toggleHint()
	},

	toggleHint: function() {
		let showHint = _.isEmpty(this.tables)
		this.$('.add-first-hint').toggleClass('is-not-displayed', !showHint)
		this.$el.toggleClass('has-hint', showHint)
	},

	loadingQueryResults: function() {
		var total = this.$('.total .panel')
		// Clear total text while loading
		total.find('.total-number').text('')
		total.find('.loading-dots-container').removeClass('is-not-displayed')
		// re-render the headers (#19066)
		_.invokeMap(this.resultViews, 'setAllFilters', this.filters)
		_.invokeMap(this.resultViews, 'renderHeader')
		// replace the table with loading dots
		_.each(this.$('.results .panel'), function(panel) {
			$(panel).addClass('is-loading')
				.find('.loading-dots-container').removeClass('is-not-displayed')
		})
	},

	// Append a placeholder panel to indicate a new field is being added.
	// It will get replaced by the real panel once renderQueryResults() is called.
	addPlaceholderPanel: function(options) {
		let content = {
			header: options.header,
			loadingDots: loadingDots()
		}
		// If the dataset ID is different from the model id, the field is a linked dataset
		if (options.datasetId !== this.model.get('rootDatasetId')) {
			content.linkedDataset = this.model.datasetsById[options.datasetId].get('label')
		}
		this.$('.results').append(loadingPanel(content))
	},

	// Sets up panel headers so the content can be sticky when
	// horizontally scrolling. #48201
	positionHeaderContent: function() {
		_.forEach(this.$('.results .panel'), e => {
			let panel = $(e)
			let containerWidth = this.$('.results').outerWidth()
			let widthDifference = panel.outerWidth() - containerWidth
			let rightPosition = widthDifference < constants.STANDARD_MARGIN/2 ?
				widthDifference : -constants.STANDARD_MARGIN/2
			let panelheader = panel.find('.panel-header')
			let scrollWidth = 5
			panelheader.width(containerWidth - constants.STANDARD_MARGIN - scrollWidth)
			panelheader.find('.right-buttons').css('right', rightPosition)
		})
	},

	renderTotalNumber: function() {
		this.$('.total .loading-dots-container').addClass('is-not-displayed')
		if (this.options.response.totalError) {
			this.$('.total .panel-content').html(
				'<div class="total-error">' +
					icon('widget-empty-state') +
				'</div>')
			return
		}

		const aggregationField = this.getAggregationField()
		const underlyingField = this.model.getUnderlyingField(aggregationField)
		const aggregationType = this.getAggregationType()
		const fieldDataType = underlyingField?.dataType
		const dataType = getAggregatedDataType(fieldDataType, aggregationType)
		var formattedTotal = formatHtmlValue({
			dataset: this.model,
			fieldId: aggregationField?.id,
			treeItemsById: this.treeItemsById,
			value: this.response.total,
			shorten: false,
			dataType,
			currencyCode: _.get(aggregationField, 'currencyCode'),
			precision: _.get(aggregationField, 'precision'),
			timeFormat: momentHelper.getTimeFormat(
				_.get(aggregationField, 'timeDisplayType')
			)
		})
		this.$('.total-number')
			.html(formattedTotal)
			.removeClass('is-not-displayed')
	},

	renderQueryResults: function() {
		this.renderActiveFilters()
		this.totalText()
		this.renderTotalNumber()

		this.resultViews = []
		let aggregationFieldId = this.getAggregationFieldId()
		let aggregationVisibleLinkedFieldId = this.getAggregationVisibleLinkedFieldId()

		var resultsContainer = this.$('.results').empty()
		var nonSecurityFilters = this._nonSecurityFilters()

		this.exportModels = {}
		// the filters that apply to the table
		let filtersByLinkGroup = _(nonSecurityFilters)
			.filter((filter) => !_.isNil(filter.operator))
			.groupBy('linkGroup')
			.value()
		for (var i=0; this.response.results != null && i<this.response.results.length; i++) {
			const result = this.response.results[i]
			const fieldId = result.fieldId
			var table = this.tables[i]
			var field = this.model.combinedFieldsById[fieldId]
			let underlying = this.model.getUnderlyingField(field)
			var options = {
				model: this.model,
				allFilters: this.filters,
				field,
				table,
				result,
				treeItemsById: this.treeItemsById,
				blank: result.blank,
				numResults: this.response.numResults,
				aggregationFieldId: aggregationFieldId,
				aggregationVisibleLinkedFieldId,
				aggregationType: this.getAggregationType(),
				filterThroughLocalDataset: this.getFilterThroughLocalDataset(),
				filtersByLinkGroup: filtersByLinkGroup,
				request: this.request,
				response: this.response,
				explore: true
			}

			var constructor = DatasetsTabularResult
			if (!result.error && TableSettings.aggregatedResult(underlying, table)) {
				constructor = DatasetsValueResult
			}

			const view = new constructor(options)
			this.addResultView(resultsContainer, view)

			this.exportModels[table.cid] = {
				table,
				field: this.model.combinedFieldsById[fieldId],
				treeItemsById: this.treeItemsById,
				rowBreakdownField: _.invoke(view, 'getBreakdownField', 'row'),
				rowArray: _.result(view, 'rowArray'),
				data: view.map /* tabular */ || result,  /* value */
				otherDatum: view.getOtherDatum && view.getOtherDatum.bind(view)
			}
		}

		this.positionHeaderContent()

		// #15803 no structure permission, can't create dataset series
		if (!permissions.anyStructure()) {
			this.$('.value').removeClass('value text-link-emphasized')
		}
	},

	// returns a view of this.filters with nothing but security filters
	_nonSecurityFilters: function() {
		return _.filter(this.filters, function(filter) {
			return _.isNil(filter.permissionId)
		})
	},

	// adds a DatasetsTabularResult view to the display, and binds all necessary
	// events
	addResultView: function(resultsContainer, view) {
		view.on('drilldown', this.drilldown.bind(this))
		view.on('back', this.back.bind(this))
		view.on('settings', this.settings.bind(this))
		view.on('delete', this.deleteTable.bind(this))
		view.on('num-results', this.dirty.bind(this, true))
		view.on('dataset-metric', this.datasetMetric.bind(this))
		view.on('change-filters', this.changeFilters.bind(this))
		view.on('sort', this.sort.bind(this))
		view.on('click-value-cell', this.clickValueCell.bind(this))
		view.on('create-dataset-metric', this.showCreateDatasetMetricDialog.bind(this))
		resultsContainer.append(view.el)
		view.render()
		this.resultViews.push(view)
	},

	/**
	 * Callback after a user clicks on a value in the table of results.
	 * Currently, this triggers a tooltip with a single options: Create Dataset Metric
	 */
	clickValueCell: function(targetEl, datasetSeriesOptions) {
		if (!shouldShowCreateDatasetMetricTooltip(targetEl)) return

		_.invoke(this.cellTooltip, 'remove')

		this.cellTooltip = new Tooltip({
			attachTo: targetEl,
			content: cellTooltipTemplate(),
			placement: 'right',
			arrow: 'center',
			extraClass: 'has-bootslide-menu'
		}).render()

		this.cellTooltip.$el.click('.create-dataset-metric', () => {
			_.invoke(this.cellTooltip, 'remove')
			this.showCreateDatasetMetricDialog(datasetSeriesOptions)
		})
	},

	showCreateDatasetMetricDialog: function(datasetSeriesOptions) {
		// #35941 Disallow dataset series with relative periods
		if (hasRelativeDateFilter(this.filters)) {
			return appDisplay.dialog(new ConfirmPrompt({
				confirmLabel: 'common.close',
				message: i18n.get('datasets.metric.relativeDateFilter'),
				confirmOnly: true
			}))
		}
		var datasetSeriesCreator = new DatasetSeriesCreator(datasetSeriesOptions)
		appDisplay.dialog(datasetSeriesCreator)
		datasetSeriesCreator.on('done', this.datasetMetric.bind(this))
	},

	// adds a filter with default settings for the selected field
	addField: function(e) {
		var fieldIdentifier = this.$('select.field').val()
		if (!fieldIdentifier) {
			return
		}

		this.addPlaceholderPanel({
			header: this.model.getFieldByFieldIdentifier(fieldIdentifier).label,
			datasetId: this.model.getDatasetByFieldIdentifier(fieldIdentifier).id
		})

		this.tables.push(new DatasetTable({}, {
			dataset: this.model,
			fieldIdentifier
		}))

		// display save controls
		this.dirty(true)
		this.query({newTable: true})

		// remove the field that was just added from the available options
		selects.update(this.$('select.field').val(''))
		this.renderFieldDropdown()
	},

	totalSettings: function(e) {
		let aggregationFieldId = this.request.aggregationFieldId ??
			// #51606 handle dataset views, which won't have the
			// aggregationFieldId specified on the request
			this.response?.dataset?.aggregationFieldId
		let aggregationField = this.model.getUnderlyingField(aggregationFieldId)
		let aggregationType = this.getAggregationType()
		let dataType = aggregationField?.dataType
		let aggregatedDataType = getAggregatedDataType(dataType, aggregationType)
		// #15803 users without any structure permission can't create dataset
		// metrics
		if (!permissions.anyStructure() ||
			// #51606 can only create dataset metrics for numeric data
			!isNumericDataType(aggregatedDataType) ||
			// can't create dataset metrics for the "list unique values"
			// aggregationType
			aggregationType == LIST_UNIQUE_VALUES) {
			// instead of displaying a menu with one option, just bring up the
			// change total display dialog
			this.changeTotalDisplay()
			return
		}

		this.totalTooltip = new Tooltip({
			attachTo: e.target,
			content: totalTooltip(),
			placement: 'below',
			arrow: 'center',
			extraClass: 'has-bootslide-menu'
		}).render()
		this.totalTooltip.$('.change-total-display').click(this.changeTotalDisplay.bind(this))
		this.totalTooltip.$('.create-dataset-metric').click(this.createDatasetMetric.bind(this))
		this.totalTooltip.$el.click(() => this.totalTooltip.remove())
	},

	onClickTotalError: function() {
		showPartialError(this.options.response.totalError)
	},

	changeTotalDisplay: function() {
		var view = new ChangeTotalDisplay({
			model: this.model,
			aggregationFieldId: this.getAggregationFieldId(),
			aggregationType: this.getAggregationType(),
			aggregationVisibleLinkedFieldId: this.getAggregationVisibleLinkedFieldId(),
			filterThroughLocalDataset: this.getFilterThroughLocalDataset()
		})
		appDisplay.dialog(view)

		view.on('done', function(data) {
			this.dirty(true)
			// TODO: don't really need to reload the whole overview
			this.query(data)
		}.bind(this))
	},

	totalText: function() {
		let aggregationVisibleLinkedFieldId = this.getAggregationVisibleLinkedFieldId()
		let totalText = fieldAggregationDescription({
			dataset: this.model,
			aggregationField: this.getAggregationField(),
			aggregationVisibleLinkedField: this.model.visibleLinkedFieldsById[aggregationVisibleLinkedFieldId],
			aggregationType: this.getAggregationType(),
			tracked: this.model.get('tracked')
		})
		this.$('.total-text').text(totalText)
	},

	/**
	 * Creates a dataset metric based off of the total display.  Dataset metrics
	 * created from values inside tables do NOT go through this method.
	 */
	createDatasetMetric: function() {
		// #35941 Disallow dataset series with relative periods
		if (hasRelativeDateFilter(this.filters)) {
			return appDisplay.dialog(new ConfirmPrompt({
				confirmLabel: 'common.close',
				message: i18n.get('datasets.metric.relativeDateFilter'),
				confirmOnly: true
			}))
		}
		const options = _.pick(this.request, 'id', 'aggregationType',
			'aggregationFieldId', 'aggregationVisibleLinkedFieldId')
		if (_.isNil(options.aggregationFieldId)) {
			// #27854 aggregationFieldId stored here for dataset views
			options.aggregationFieldId = this.model.get('aggregationFieldId')
		}
		// #27049
		if (!options.aggregationFieldId) {
			options.aggregationFieldId = TOTAL
		}
		options.model = this.model
		options.columnFieldId = _.get(options, 'aggregationFieldId',
			this.model.get('aggregationFieldId'))
		options.columnVisibleLinkedFieldId =
			options.aggregationVisibleLinkedFieldId ??
			this.model.get('aggregationVisibleLinkedFieldId')
		options.columnAggregationType = options.aggregationType ??
			this.model.get('aggregationType')
		let calendarFieldIdentifier = this.model.getCalendarFieldIdentifier()
		if (!_.isNil(calendarFieldIdentifier)) {
			options.calendarFieldIdentifier = calendarFieldIdentifier
			let calendarIds = this.model.fieldIdentifierToIds(calendarFieldIdentifier)
			options.calendarFieldId = calendarIds.fieldId
			options.calendarVisibleLinkedFieldId = calendarIds.visibleLinkedFieldId
		}
		options.filters = this.filters
		var form = new DatasetSeriesCreator(options)
		appDisplay.dialog(form)
		form.on('done', this.datasetMetric.bind(this))
	},

	/**
	 * @param {DatasetTable} table
	 */
	drilldown: function(table, value) {
		this.dirty(true)

		let field = this.model.combinedFieldsById[table.get('fieldId')]
		field = this.model.getUnderlyingField(field)
		this.filters = applyFilter(field, this.filters, table, value)
		this.query()
	},

	back: function(table, result) {
		this.dirty(true)

		let field = this.model.combinedFieldsById[table.get('fieldId')]
		field = this.model.getUnderlyingField(field)
		this.filters = applyFilter.back(field, this.filters, table, result)
		this.query()
	},

	sort: function(table, sortProps) {
		this.dirty(true)
	},

	rowHighlights(e) {
		let tableRow = $(e.currentTarget).closest('tr')
		let rowId = tableRow.data('id')
		// Other tables can have rows with the same IDs.
		// Limit highlighting to this table. Issue #18447
		let table = tableRow.closest('table')
		if (e.type === 'mouseenter') {
			table.find(`tr[data-id="${_.escape(rowId)}"]`).addClass('is-highlighted')
		} else {
			table.find(`tr[data-id="${_.escape(rowId)}"]`).removeClass('is-highlighted')
		}
	},

	deleteTable: function(index) {
		this.tables.splice(index, 1)
		this.response.results.splice(index, 1) // #41516
		this.resultViews.splice(index, 1)
		// #52740 also remove the corresponding table on the request, so it
		// doesn't seem to reappear if the page is refreshed
		this.request.tables = this.tables


		// remove the panel from the display right away now that we have fancy
		// loading dots showing in all our other panels (#
		this.$('.results .panel').eq(index).remove()

		this.dirty(true)
		// #16605 no need to call this.query

		// add back the field that was filtered on so it can be chosen again
		this.renderFieldDropdown()
		_.invokeMap([this.settingsTooltip, this.cellTooltip], 'remove')
	},

	isExportable: function() {
		return this.$('.results .panel-with-table').length > 0
	},

	exportTable: function() {
		const tableEls = this.$('.results .panel-with-table')
		return datasetsOverviewExport.export(tableEls, this.model, this.exportModels)
	},

	/**
	 * Callback triggered after clicking on the gear icon for a particular
	 * table.
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.field the field this result is based on
	 *
	 * @param {Object} options.filter the filter used to create the result
	 *
	 * @param {Object} options.result the result of the filter
	 *
	 * @param {Object} options.treeItemsById a hash of tree IDs to tree items
	 *
	 * @param {DatasetTable} options.table the table whose settings we're modifying
	 */
	settings: function(options) {
		var index = _.findIndex(this.tables, function(t) {
			return t == options.table
		})

		let settingsModel = TableSettings.SettingsModel.fromOptions(options, this.model)
		// only show sorting options on dataset table widgets
		settingsModel.showSort = false

		var tableSettings = new TableSettings({ model: settingsModel })
		_.result(this.settingsTooltip, 'remove')
		this.settingsTooltip = new Tooltip({
			attachTo: this.$('.results .panel:eq(' + index + ') .icon-settings'),
			content: tableSettings,
			placement: 'left',
			arrow: 'top',
			extraClass: 'has-bootslide-menu'
		}).render()

		// setup events

		tableSettings.on('all', () => {
			this.settingsTooltip.remove()
		})
		// #14352 Clicking OnOffToggles shouldn't close menu
		settingsModel.on('all', (event) => {
			const excludedEvents = [
				'record',
				'change',
				'change:filter',
				'change:abbreviateNumbers',
				'change:showKeys',
				'change:showAncestors'
			]
			// #36028 do not close the tooltip menu if the user clicked on the
			// 'Group Similar Time Ranges' row option
			const rowsChangeToSimilarTimeRanges = event === 'change:summaryType' &&
				settingsModel.get('summaryType') === 'similar-time-ranges'

			if (!excludedEvents.includes(event) && !rowsChangeToSimilarTimeRanges) {
				this.settingsTooltip.remove()
			}
		})

		settingsModel.on('change:summaryType', () =>
			this.onChangeSummaryType(settingsModel, options.table))

		// the "Choose Rows" option for date fields
		tableSettings.on('change-breakdown-calendar-id', () =>
			this.onChangeBreakdownCalendarId(settingsModel, options.table))

		// #36028 fired when these calendar id's are changed via the
		// 'similar-time-ranges' option
		tableSettings.on('updateSimilarTimeRanges', ({ summaryType, groupCalendarId, breakdownCalendarId }) =>
			this.updateSimilarTimeRanges({
				settingsModel, summaryType, groupCalendarId, breakdownCalendarId,
				table: options.table
			}))

		tableSettings.on('view-data-source', () => this.viewDataSource(options.table))

		tableSettings.on('choose-columns', () =>
			this.chooseColumns(options.table, options.result))

		tableSettings.on('set-repeat-by-grouping-columns',
			this.setRepeatByGrouping.bind(this, options.table, 'column'))
		tableSettings.on('set-repeat-by-grouping-rows',
			this.setRepeatByGrouping.bind(this, options.table, 'row'))

		settingsModel.table.on('change:numResults', function () {
			const numResults = settingsModel.table.get('numResults')
			options.table.set({ numResults })
			this.dirty(true)
			_.invoke(this.resultViews[index], 'setNumDisplayed', options.table.get('numResults'))
		}.bind(this))

		settingsModel.on('change:setAsAppCalendar', () =>
			this.onChangeSetAsAppCalendar(settingsModel, options))

		settingsModel.on('change:abbreviateNumbers', function () {
			this.tables[index].set('abbreviateNumbers', settingsModel.get('abbreviateNumbers'))
			this.dirty(true)
			this.resultViews[index].renderRows()
		}.bind(this))

		settingsModel.on('change:showKeys', function () {
			this.tables[index].set('showKeys', settingsModel.get('showKeys'))
			this.dirty(true)
			this.resultViews[index].renderRows()
		}.bind(this))

		settingsModel.on('change:showAncestors', function () {
			this.tables[index].set('showAncestors', settingsModel.get('showAncestors'))
			this.dirty(true)
			this.resultViews[index].renderRows()
		}.bind(this))
	},

	/**
	 * @param {SettingsModel} settingsModel
	 * @param {DatasetTable} table
	 */
	onChangeSummaryType: function(settingsModel, table) {
		const summaryType = settingsModel.get('summaryType')
		// #38378 once "Group Similar Time Ranges" is selected, the user still
		// has to configure the calendars, so don't bother re-querying yet
		if (summaryType === 'similar-time-ranges') return

		table.set('summaryType', summaryType)
		table.unset('breakdownCalendarId')
		delete table.unset('groupCalendarId')
		settingsModel.unset('breakdownCalendarId', { silent: true })
		this.dirty(true)
		this.query()
	},

	/**
	 * @param {SettingsModel} settingsModel
	 * @param {DatasetTable} table
	 */
	onChangeBreakdownCalendarId: function(settingsModel, table) {
		const breakdownCalendarId = settingsModel.get('breakdownCalendarId')
		table.set({ breakdownCalendarId })
		table.unset('summaryType')
		settingsModel.unset('summaryType', { silent: true })
		this.dirty(true)
		this.query()
	},

	/**
	 * @param {SettingsModel} settingsModel
	 * @param {DatasetTable} table
	 * @param {String} summaryType
	 * @param {Number} groupCalendarId
	 * @param {Number} breakdownCalendarId
	 */
	updateSimilarTimeRanges: function({settingsModel, table,
			summaryType, groupCalendarId, breakdownCalendarId }) {
		updateSimilarTimeRanges({ settingsModel, table,
			summaryType, groupCalendarId, breakdownCalendarId })
		this.dirty(true)
		this.query()
	},

	/**
	 * @param {DatasetTable} table
	 */
	viewDataSource: function(table) {
		appDisplay.dialog(new ViewTableDataSource({
			model: this.model,
			table,
			showDatasetLink: false
		}))
	},

	/**
	 * @param {DatasetTable} table
	 */
	chooseColumns: function(table, result) {
		let xhr = $.get('api/datasets/data-source-info')
		appDisplay.dialog(xhr, ({ datasets }) => {
			let chooseColumns = new ChooseColumns({
				model: this.model,
				datasets,
				treeItemsById: this.treeItemsById,
				table,
				aggregationFieldId: this.getAggregationFieldId(),
				aggregationVisibleLinkedFieldId: this.getAggregationVisibleLinkedFieldId(),
				aggregationType: this.getAggregationType(),
				filterThroughLocalDataset: this.getFilterThroughLocalDataset(),
				result,
				// we want to support relative dates on the Datasets Explore tab to
				// support dynamic columns like SA per 1000 from #27466
				allowAppCalendar: true
			})
			chooseColumns.on('done', data => {
				table.set(data)
				this.dirty(true)
				this.query()
			})
			return chooseColumns
		})
	},

	onChangeSetAsAppCalendar: function(settingsModel, options) {
		var ids = _.pick(settingsModel.get('table'), 'fieldId',
			'visibleLinkedFieldId')
		if (!settingsModel.get('setAsAppCalendar')) {
			ids = { fieldId: ALL_TIME }
		}
		this.model.set({
			selectedCalendarFieldId: ids.fieldId,
			selectedCalendarVisibleLinkedFieldId: ids.visibleLinkedFieldId
		})
		let fieldIdentifier = this.model.idsToFieldIdentifier(ids)
		options.selectedCalendarFieldIdentifier = fieldIdentifier
		this.header.selectedCalendarFieldIdentifier = fieldIdentifier
		this.header.periodDisplay.render()
		this.togglePeriodDisplay()
		this.dirty(true)
		this.query()
	},

	setRepeatByGrouping: function(table, repeatByType) {
		const editedGroupingIdx = _.findIndex(table.get('groupings'), existingGrouping =>
			existingGrouping && existingGrouping.type === getRepeatByGroupingType(repeatByType))
		const xhr = $.get('api/datasets/' + this.model.id + '/field-suggestions')
		appDisplay.dialog(xhr, (suggestions) => {
			// uppercase the type to account for camel case
			const repeatByGroupingWizard = new RepeatByGroupingWizard({
				model: this.model,
				table,
				repeatByType,
				suggestions: suggestions,
				grouping: table.get(getRepeatByGroupingKey(repeatByType))
			})
			repeatByGroupingWizard.on('done', function(grouping) {
				this.onRepeatByGroupingWizardDone(repeatByType, table, grouping, editedGroupingIdx)
				this.dirty(true)
				this.query()
			}.bind(this))
			return repeatByGroupingWizard._view()
		})
	},

	onRepeatByGroupingWizardDone: function(repeatingType, table, grouping, editedGroupingIdx) {
		const groupingKey = getRepeatByGroupingKey(repeatingType)
		const groupings = table.get('groupings') || []

		// #20102 make sure an invalid percentageOf isn't selected
		let percentageOf = table.get('percentageOf')

		if (_.isEmpty(grouping)) {
			// if the grouping is empty, that means the toggle to show it was off
			// so delete the existing groupings of this same type
			if (editedGroupingIdx >= 0) {
				groupings.splice(editedGroupingIdx, 1)
				table.set('groupings', groupings)
			}
			table.unset(groupingKey)
			if (repeatingType === 'row') {
				if (percentageOf === 'row') {
					percentageOf = 'everything'
				} else if (percentageOf === 'value-and-row') {
					percentageOf = 'value'
				}
			}
			if (repeatingType === 'column') {
				if (percentageOf === 'column') {
					percentageOf = 'everything'
				} else if (percentageOf === 'value-and-column') {
					percentageOf = 'value'
				}
			}
		} else {
			if (grouping.fieldId) {
				if (editedGroupingIdx >= 0) {
					groupings[editedGroupingIdx] = grouping
				} else {
					groupings.push(grouping)
				}
				table.set('groupings', groupings)
				table.set(groupingKey, grouping)
				table.set(getRepeatByGroupingKey(repeatingType), grouping)
			}
		}
		if (_.isEmpty(table.get('repeatingRowGrouping')) &&
			_.isEmpty(table.get('repeatingColumnGrouping'))) {
			percentageOf = 'everything'
		}
		table.set('percentageOf', percentageOf)
	},

	fieldList: function() {
		var xhr = $.get('api/datasets/' + this.model.id + '/field-examples')
		appDisplay.dialog(xhr, function(examples) {
			var fieldList = new FieldList({
				model: this.model,
				tables: this.tables,
				examples: examples
			})
			fieldList.on('done', function(tables) {
				this.tables = tables
				this.dirty(true)
				this.query()
			}.bind(this))
			return fieldList
		}.bind(this))
	},

	/**
	 * Displays a success message after a dataset metric is added
	 * @param {Object} data the data used to create the dataset metric
	 * @param {Object} response the data in the response from the server
	 */
	datasetMetric: function(data, response) {
		let key = 'datasets.metric.success.'
		let highlighted = highlight(data.label)
		let href = `scorecards/${response.id}/edit`
		let edit = _.escape(i18n.get('common.edit'))
		let link = `<a class="sp-navigate text-link" href="${href}">${edit}</a>`
		let args = [ highlighted, link ]
		// if this is an existing metric
		if (data.series) {
			key += 'existing'
			let series = _.escape(i18n.get(data.series))
			args = [ series ].concat(args)
		} else {
			key += 'new'
		}
		let message = `${i18n.get(key, ...args)}
			<span class="hide-banner"> ${icon('cross')}</span>`
		this.showBanner(message)
	},

	changeFilters: function(oldFilters, newFilters) {
		// remove all the old filters
		this.filters = _.remove(this.filters, f => -1 == _.indexOf(oldFilters, f))
		// add the new filters
		this.filters = this.filters.concat(newFilters)
		this.dirty(true)
		this.query()
	},

	query: function() {
		DatasetsQueryView.prototype.query.apply(this, arguments)
		this.toggleHint()
		// Must be called after this.request is set in datasets-query-view
		this.totalText()
	},

	save: function() {
		// #35728 re-render the whole view, this is needed because datasets-overview.js#settings
		// has a parameter: options that holds references to tables, and the reference is stale
		// when we don't re-render
		return DatasetsQueryView.prototype.save.apply(this, arguments)
			.then(() => this.render())
	},

	remove: function() {
		DatasetsQueryView.prototype.remove.apply(this, arguments)
		_.invokeMap([
			this.covertButtonTooltips, this.settingsTooltip, this.totalTooltip,
			this.cellTooltip
		], 'remove')
		_.invokeMap(this.resultViews, 'remove')
	}

})

DatasetsOverview.loadOptions = () => ({
	records: false,
	showTables: true,
	// #30105 needed for both snapshot and non-snapshot metrics
	calendarPeriodId: globals.periodId,
	// the server will only send it if it makes sense
	others: true
})

export default DatasetsOverview

DatasetsOverview.__filename__ = 'datasets/overview/datasets-overview.js'
